module.exports = __webpack_public_path__ + "static/img/101366.28e3d69c.png";